module.exports = ['$window', '$translate', '$$pop', '$q', function($window, $translate, $$pop, $q) {
  setItem('LS', 'LS')
  removeItem('LS')

  // 防止多次弹窗
  let popUp = null
  function showPopUp(msg, type = 'alert') {
    if (popUp) return $q.resolve(false)

    popUp = $translate(msg)
    return popUp.then(res => $$pop[`${type}Popup`]('', res).finally(_ => (popUp = null)))
  }

  // 检查localstorage的支持情况
  function checkSupport() {
    const isSupportLocalStorage = !!window.localStorage
    !isSupportLocalStorage && showPopUp('TIPS.BROWSER_STORAGE_NOT_SUPPORT')
    return isSupportLocalStorage
  }

  function setItem(key, value) {
    if (!checkSupport()) return

    try {
      $window.localStorage.setItem(key, JSON.stringify(value))
    } catch (e) {
      console.error('setItem error', e)

      // http://stackoverflow.com/questions/14555347/html5-localstorage-error-with-safari-quota-exceeded-err-dom-exception-22-an
      // 浏览器存储空间不足，系统设置中清除浏览器数据
      // using synchronous way to load resources
      if (~['QuotaExceededError', 'QUOTA_EXCEEDED_ERR', 'NS_ERROR_DOM_QUOTA_REACHED'].indexOf(e.name)) {
        showPopUp('TIPS.BROWSER_STORAGE_QUOTA_EXCEED', 'confirm').then(res => {
          if (!res) return

          console.log('clear localStorage')
          $window.localStorage.clear()
        })
      } else {
        const errMsg = e.name || e.message || 'BROWSER_STORAGE_NOT_SUPPORT'
        showPopUp(`TIPS.${errMsg}`)
      }
    }
  }

  function getItem(key, defaultValue = {}) {
    if (!checkSupport()) return

    return JSON.parse($window.localStorage.getItem(key) || JSON.stringify(defaultValue))
  }

  function removeItem(key) {
    if (!checkSupport()) return

    $window.localStorage.removeItem(key)
  }

  return {
    setItem,
    getItem,
    removeItem
  }
}]



// WEBPACK FOOTER //
// ./src/js/infrastructure/LocalStorage.js